import MiniGamesCatagory from './index.vue';

export default {
  MiniGamesCatagory,
};
